// Parametric vine math for the Garden vine renderer. Originally extracted from
// Garden.tsx (rule #4) to share with a home-view gateway glimpse; that glimpse
// was removed, so Garden is the sole consumer again. Kept as a standalone pure
// module (re-inlining would be needless churn). The function BODIES must stay
// byte-equivalent to the Garden originals so the vine drifts identically; do
// not "improve" them.

// Parametric vine centerline. Used for the path AND for placing
// knuckles/tendrils. Same formula as pre-virtualization so the vine
// drifts identically.
export function getVineX(t: number): number {
  return 32 + Math.sin(t * 8.5) * 9 + Math.cos(t * 19) * 3 + Math.sin(t * 41) * 1.2;
}

// Deterministic per-index pseudo-random for knuckle/tendril variance.
// Seeded so the vine renders identically on every load; replacing this
// with Math.random() makes the layout shift each time the user reopens
// the Garden.
export function vineRand(i: number, seed: number): number {
  const v = Math.sin((i + 1) * 12.9898 + seed * 78.233) * 43758.5453;
  return v - Math.floor(v);
}
